module.exports = __webpack_public_path__ + "fonts/SUIT-SemiBold.3f033d89.woff2";